import { ISalesTeamPosition } from '@user/store/salesTeam/typings' // adjust import if needed

export function getValidParentsForPosition(
  positions: ISalesTeamPosition[],
  currentPositionId?: number | null,
): ISalesTeamPosition[] {
  // Base list – only non-system positions
  const baseList = positions.filter((p) => !p.systemCreated)

  // If we're creating a new position, there are no descendants to worry about
  if (!currentPositionId) {
    return baseList
  }

  // Build parentId -> children[] map
  const childrenMap = new Map<number, ISalesTeamPosition[]>()

  for (const pos of baseList) {
    if (pos.parentId == null || pos.id == null) continue

    const list = childrenMap.get(pos.parentId) ?? []
    list.push(pos)
    childrenMap.set(pos.parentId, list)
  }

  // Collect all descendants (including the node itself in the blocked set)
  const blocked = new Set<number>()
  const stack: number[] = [currentPositionId]

  while (stack.length > 0) {
    const parentId = stack.pop()!
    // we block the starting node as well
    blocked.add(parentId)

    const children = childrenMap.get(parentId) ?? []
    for (const child of children) {
      if (child.id == null) continue
      if (!blocked.has(child.id)) {
        stack.push(child.id)
      }
    }
  }

  // Filter out the current node and its descendants
  return baseList.filter((p) => p.id != null && !blocked.has(p.id))
}
